export default __webpack_public_path__ + "static/media/logo.91f42322.svg";